// src/BenefitsSection.js
import React from 'react';
import './BenefitsSection.css';

function BenefitsSection() {
  return (
    <section className="benefits">
      <h2>🌟 Why Join GenAI KrishiTech?</h2>
      <ul>
        <li>💡 Learn to build real GenAI-based applications — no coding experience required</li>
        <li>☁️ Hands-on with Azure, AWS & GCP deployments</li>
        <li>🎓 Mentorship & certification by industry experts</li>
        <li>📈 Resume building & interview prep</li>
        <li>💼 Learn Sales, Marketing & Entrepreneurship</li>
        <li>🏆 Monthly rewards & stipends for top performers</li>
        <li>💸 Start earning in 2 months — top students get hired</li>
      </ul>
    </section>
  );
}

export default BenefitsSection;
